export const Routes = {
  PRIVATECOLLECTIONS: 'my-recipe-collection',
  PRIVATERECIPES: 'my-recipes',
  RAPSCOLLECTIONS: 'raps-recipe-collection',
  RAPSRECIPES: 'raps-recipes',
};
